import React from "react"
import { TokenRow } from "./token_row"
import { appStrings } from "../../common/strings/app_strings"
import styled from "styled-components"
import { DashHeader } from "../styled_components/dash_header"

const {
    accessTokensHeader,
    accessTokensSubHeader,
    appName,
    publisher,
    accessType,
    revokeAccess,
    noTokens,
} = appStrings.connectedApps

export const SystemAccessTokens = ({ tokens, handleRevokeOAuthToken }) => {

    const tokensLength = tokens.length

    return (
        <div>
            <DashHeader>
                <h4>{accessTokensHeader}</h4>
                <p>{accessTokensSubHeader}</p>
            </DashHeader>

            <TokenRowsWrapper>
                <TokensHeaderRow>
                    <ColumnHeaders>
                        <div>
                            <p>{appName}</p>
                        </div>
                        <div>
                            <p>{publisher}</p>
                        </div>
                        <div>
                            <p>{accessType}</p>
                        </div>
                    </ColumnHeaders>
                    <RevokeContainer className="revoke-text-container">
                        <p>{revokeAccess}</p>
                    </RevokeContainer>
                </TokensHeaderRow>

                {tokensLength < 1 ? (
                    <DefaultTokenRow>{noTokens}</DefaultTokenRow>
                ) : (
                    <div>
                        {tokens &&
                            tokens.map(token => {
                                return (
                                    <TokenRow
                                        token={token}
                                        key={token.id}
                                        handleRevokeOAuthToken={
                                            handleRevokeOAuthToken
                                        }
                                    />
                                )
                            })}
                    </div>
                )}
            </TokenRowsWrapper>
        </div>
    )
}

const TokenRowsWrapper = styled.div`
    border: 1px solid #dde0e2;
    border-radius: 4px;
    margin: 20px;

    :last-child {
        border-bottom: none;
    }
`

const TokensHeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    background-color: #f8fafb;
    height: 40px;
    align-items: center;
    padding: 0 20px;
    border-bottom: 1px solid #dde0e2;

    @media (max-width: 700px) {
        display: none;
    }

    p {
        font-size: 12px;
        font-weight: bold;
        margin: 0;
    }
`
const RevokeContainer = styled.div`
    width: 15%;
    text-align: center;
`

const ColumnHeaders = styled.section`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;

    div {
        display: flex;
        width: 33.3%;
        height: 100%;
        padding-right: 10px;
    }
`
const DefaultTokenRow = styled.div`
     {
        padding: 20px;
        text-align: center;
        width: 100%;
        border-bottom: 1px solid #dde0e2;
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/system_access_tokens.jsx